class Tabs extends HTMLElement {
  constructor() {
    super();

    this.TAB_ACTIVE_CLASS = 'tabs__tab--active';
    this.CONTENT_ACTIVE_CLASS = 'tabs__content--active';

    this.tabs = this.querySelectorAll('.js-tab');
    this.tabContents = this.querySelectorAll('.js-tab-content');

    if (!this.tabs.length) return;

    this.tabs.forEach(tab => tab.addEventListener('click', () => this.onTabClick(tab)));
  }

  onTabClick(tab) {
    const tabContent = this.querySelector(`.js-tab-content[data-tab="${tab.getAttribute('data-tab')}"]`);

    if (!tabContent) return;

    this.tabs.forEach(tab => tab.classList.remove(this.TAB_ACTIVE_CLASS));
    this.tabContents.forEach(tabContent => tabContent.classList.remove(this.CONTENT_ACTIVE_CLASS));

    tab.classList.add(this.TAB_ACTIVE_CLASS);
    tabContent.classList.add(this.CONTENT_ACTIVE_CLASS);
  }
}

if (!customElements.get('tabs-component')) customElements.define('tabs-component', Tabs);